export const INITIAL_STATUS_FILTER = [
  { cdSituacao: 2 },
  { cdSituacao: 4 },
  { cdSituacao: 9 },
  { cdSituacao: 12 },
  { cdSituacao: 13 },
];

export const STATUS_CODES = {
  EM_CONSTRUCAO: 1,
  EM_ANALISE: 2,
  AGUARDANDO_PAGAMENTO: 3,
  AGUARDANDO_RESOLUCAO_PENDENCIAS: 4,
  APROVADO: 5,
  REPROVADO: 6,
  CANCELADO: 7,
  AGUARDANDO_ASSINATURA_DOCUMENTO: 8,
  AGUARDANDO_AJUSTES_DOCUMENTO: 9,
  AGUARDANDO_APROVACAO: 10,
  AGUARDANDO_VISTORIA: 11,
  RETORNO_VISTORIADOR: 12,
  RETORNO_DIRETOR_GERAL: 13,
};

export const STATUS_COLORS = {
  [STATUS_CODES.EM_CONSTRUCAO]: {
    name: 'Em construção',
    color: '#FFC404',
  },
  [STATUS_CODES.EM_ANALISE]: {
    name: 'Em análise',
    color: '#1D7CCC',
  },
  [STATUS_CODES.AGUARDANDO_PAGAMENTO]: {
    name: 'Aguardando pagamento',
    color: '#FE7004',
  },
  [STATUS_CODES.AGUARDANDO_RESOLUCAO_PENDENCIAS]: {
    name: 'Aguardando resolução de pendências',
    color: '#00B4E3',
  },
  [STATUS_CODES.APROVADO]: {
    name: 'Aprovado',
    color: '#039415',
  },
  [STATUS_CODES.REPROVADO]: {
    name: 'Reprovado',
    color: '#A40943',
  },
  [STATUS_CODES.CANCELADO]: {
    name: 'Cancelado',
    color: '#ED112A',
  },
  [STATUS_CODES.AGUARDANDO_ASSINATURA_DOCUMENTO]: {
    name: 'Aguardando assinatura documento',
    color: '#00B4E3',
  },
  [STATUS_CODES.AGUARDANDO_AJUSTES_DOCUMENTO]: {
    name: 'Aguardando ajustes doc./solicitação',
    color: '#3e827E',
  },
  [STATUS_CODES.AGUARDANDO_APROVACAO]: {
    name: 'Aguardando aprovação',
    color: '#008FE3',
  },
  [STATUS_CODES.AGUARDANDO_VISTORIA]: {
    name: 'Aguardando vistoria',
    color: '#FE9F00',
  },
  [STATUS_CODES.RETORNO_VISTORIADOR]: {
    name: 'Retorno do vistoriador',
    color: '#3eA27E',
  },
  [STATUS_CODES.RETORNO_DIRETOR_GERAL]: {
    name: 'Retorno do diretor geral',
    color: '#3eA27E',
  }
};
